'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactCssModules = require('react-css-modules');

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _config = require('../../config');

var _config2 = _interopRequireDefault(_config);

var _components = require('../../components');

var _InlineSignup = require('./InlineSignup.css');

var _InlineSignup2 = _interopRequireDefault(_InlineSignup);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var InlineSignup = (_dec = (0, _reactCssModules2.default)(_InlineSignup2.default, { allowMultiple: true }), _dec(_class = function (_Component) {
  (0, _inherits3.default)(InlineSignup, _Component);

  function InlineSignup() {
    (0, _classCallCheck3.default)(this, InlineSignup);
    return (0, _possibleConstructorReturn3.default)(this, (InlineSignup.__proto__ || (0, _getPrototypeOf2.default)(InlineSignup)).apply(this, arguments));
  }

  (0, _createClass3.default)(InlineSignup, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      return _react2.default.createElement(
        'div',
        { styleName: 'inline-signup', 'aria-labelledby': 'inline-signup__headline' },
        _react2.default.createElement(
          'div',
          { styleName: 'inline-signup__icon', 'aria-hidden': 'true' },
          _react2.default.createElement(_components.LinkIcon, { faclass: 'fa-envelope', nospace: true })
        ),
        _react2.default.createElement(
          'h3',
          { id: 'inline-signup__headline', styleName: 'inline-signup__headline' },
          'See the impact of your investments'
        ),
        _react2.default.createElement(
          'h3',
          { styleName: 'inline-signup__copy' },
          'Regular updates on sustainability risks and ethical concerns in everyday investment products'
        ),
        _react2.default.createElement(
          'div',
          { styleName: 'inline-signup__form-wrap' },
          _react2.default.createElement(
            'form',
            {
              styleName: 'inline-signup__form',
              acceptCharset: 'UTF-8',
              method: 'post',
              action: _config2.default.signupForm.url,
              target: 'signup_confirmation',
              ref: function ref(el) {
                return _this2.myInlineFormRef = el;
              }
            },
            _react2.default.createElement(
              'div',
              { style: {
                  position: 'absolute',
                  left: '-9999px',
                  top: '-9999px'
                } },
              _react2.default.createElement(
                'label',
                { htmlFor: 'pardot_extra_field' },
                'Comments'
              ),
              _react2.default.createElement('input', { type: 'text', id: 'pardot_extra_field', name: 'pardot_extra_field' })
            ),
            _react2.default.createElement(
              'label',
              {
                htmlFor: _config2.default.signupForm.id,
                style: {
                  position: 'absolute',
                  width: '1px',
                  height: '1px',
                  margin: '-1px',
                  padding: '0',
                  overflow: 'hidden',
                  clip: 'rect(0, 0, 0, 0)',
                  border: '0'
                }
              },
              'Email address'
            ),
            _react2.default.createElement('input', {
              id: _config2.default.signupForm.id,
              styleName: 'inline-signup__input',
              name: _config2.default.signupForm.id,
              type: 'email',
              placeholder: 'Enter your email address',
              autocomplete: 'email',
              required: true,
              'aria-required': 'true'
            }),
            _react2.default.createElement(
              'button',
              {
                styleName: 'inline-signup__submit',
                type: 'submit'
              },
              'Sign up'
            )
          )
        )
      );
    }
  }]);
  return InlineSignup;
}(_react.Component)) || _class);
exports.default = InlineSignup;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/core/InlineSignup/InlineSignup.js
// module id = 1362
// module chunks = 0